import { ComponentController as BpController, DisplayMode } from '@rta/rta-blueprint-component';
import { useSubscription } from '@rta/rta-blueprint-library';

import { CornerTrimIcon } from '@components';
import { Feature, FeatureParams, Require } from '..';

type UseShowCornerTrimFeatureParams = Require<FeatureParams, 'controller'>;

export const useShowCornerTrimFeature = (params: UseShowCornerTrimFeatureParams): Feature<boolean> => {
	const { controller } = params;

	const isBlueprintController = controller instanceof BpController;
	const kitchen = isBlueprintController ? controller.kitchen : null;

	useSubscription(controller, false, [['navigation-display-mode', '*']]);

	// trim events bubble up the kitchen tree only, they never reach the controller
	useSubscription(kitchen, false, [['panel_trim', '*'], ['panel_trims', '*'], ['island_size', '*']]);

	const displayMode = isBlueprintController ? controller.navigation.displayMode : null;
	const isCornerTrimActive = displayMode === DisplayMode.CornerTrim || displayMode === DisplayMode.CornerTrimManufacturing;

	// Only flat trims are shown in this view, so an island with none has nothing to draw
	const hasFlatTrims = kitchen?.design?.islands?.children?.some((island) => (
		island?.panelTrims?.children?.some((panelTrim) => panelTrim?.isFlat) ?? false
	));

	const disabled = !isBlueprintController || displayMode === null || !hasFlatTrims;

	return {
		name: 'show-corner-trim',
		label: 'corner trim',
		shortcut: '',
		tooltip: 'Show corner trims',
		icon: (props = {}) => <CornerTrimIcon color={disabled ? 'lightgray' : (isCornerTrimActive ? 'green' : 'black')} {...props} />,
		disabled,
		value: isCornerTrimActive,
		hidden: false,
		handler: () => {
			if (controller instanceof BpController) {
				controller.navigation.displayMode = DisplayMode.CornerTrim;
			}
		}
	};
};
